import React, { useEffect, useState } from 'react';
import { X, Plus, Trash2, Send } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../api';
import { mensajeErrorApi } from '../apiErrors';

function itemVacio() {
  return { descripcion: '', link: '', cantidad: 1, variante: '' };
}

export default function SolicitarCompraAsistidaModal({ onClose, onCreada }) {
  const [nombre, setNombre] = useState('');
  const [apellido, setApellido] = useState('');
  const [email, setEmail] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [presupuesto, setPresupuesto] = useState('');
  const [formaPago, setFormaPago] = useState('transferencia');
  const [items, setItems] = useState([itemVacio()]);
  const [enviando, setEnviando] = useState(false);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    api.get('/mi-perfil/').then((res) => {
      const c = res.data?.cliente;
      if (c) {
        setNombre(c.user?.first_name || '');
        setApellido(c.user?.last_name || '');
        setEmail(c.user?.email || '');
        setWhatsapp(c.whatsapp || '');
      }
    }).catch(() => {}).finally(() => setCargando(false));
  }, []);

  const actualizarItem = (i, campo, valor) => {
    setItems((prev) => prev.map((it, idx) => (idx === i ? { ...it, [campo]: valor } : it)));
  };

  const agregarItem = () => setItems((prev) => [...prev, itemVacio()]);
  const quitarItem = (i) => setItems((prev) => prev.filter((_, idx) => idx !== i));

  const enviar = async (e) => {
    e.preventDefault();
    const itemsValidos = items.filter((it) => it.descripcion.trim());
    if (itemsValidos.length === 0) {
      toast.error('Agrega al menos un artículo con descripción.');
      return;
    }
    setEnviando(true);
    try {
      const res = await api.post('/compra-asistida/', {
        nombre, apellido, email, whatsapp,
        forma_pago_preferida: formaPago,
        presupuesto_estimado: presupuesto || null,
        items: itemsValidos,
      });
      toast.success('Solicitud enviada — te contactaremos con la cotización.');
      onCreada(res.data);
    } catch (err) {
      toast.error(mensajeErrorApi(err, 'No se pudo enviar la solicitud.'));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '620px', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3>Solicitar Compra Asistida</h3>
          <button className="btn-ghost" onClick={onClose}><X size={18} /></button>
        </div>

        {cargando ? (
          <p className="text-secondary">Cargando...</p>
        ) : (
          <form onSubmit={enviar} className="form-stack">
            <p className="text-sm text-secondary">
              Cuéntanos qué quieres comprar y te enviamos la cotización con la comisión del servicio (10% del valor, mínimo $10, + IVA).
            </p>

            <div className="form-row">
              <div>
                <label>Nombre *</label>
                <input value={nombre} onChange={(e) => setNombre(e.target.value)} required />
              </div>
              <div>
                <label>Apellido *</label>
                <input value={apellido} onChange={(e) => setApellido(e.target.value)} required />
              </div>
            </div>
            <div className="form-row">
              <div>
                <label>Correo *</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <div>
                <label>WhatsApp *</label>
                <input value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} placeholder="593 99 999 9999" required />
              </div>
            </div>

            <div>
              <label>Artículos a comprar</label>
              <div style={{ display: 'grid', gap: 'var(--spacing-3)' }}>
                {items.map((it, i) => (
                  <div key={i} className="card" style={{ padding: 'var(--spacing-3)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                      <span className="text-sm text-secondary">Artículo {i + 1}</span>
                      {items.length > 1 && (
                        <button type="button" className="btn-ghost btn-sm" onClick={() => quitarItem(i)}>
                          <Trash2 size={14} />
                        </button>
                      )}
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <input
                        placeholder="Descripción del producto"
                        value={it.descripcion}
                        onChange={(e) => actualizarItem(i, 'descripcion', e.target.value)}
                      />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <input
                        type="url"
                        placeholder="Link de la tienda (Amazon, Shein, eBay, etc.)"
                        value={it.link}
                        onChange={(e) => actualizarItem(i, 'link', e.target.value)}
                      />
                    </div>
                    <div className="form-row">
                      <input
                        type="number" min="1" placeholder="Cantidad"
                        value={it.cantidad}
                        onChange={(e) => actualizarItem(i, 'cantidad', e.target.value)}
                      />
                      <input
                        placeholder="Talla / color / variante (opcional)"
                        value={it.variante}
                        onChange={(e) => actualizarItem(i, 'variante', e.target.value)}
                      />
                    </div>
                  </div>
                ))}
              </div>
              <button type="button" className="btn-secondary btn-sm" onClick={agregarItem} style={{ marginTop: 'var(--spacing-2)' }}>
                <Plus size={14} /> Agregar otro artículo
              </button>
            </div>

            <div className="form-row">
              <div>
                <label>Presupuesto estimado (USD, opcional)</label>
                <input type="number" step="0.01" min="0" value={presupuesto} onChange={(e) => setPresupuesto(e.target.value)} placeholder="¿Cuánto esperas gastar aprox?" />
              </div>
              <div>
                <label>Forma de pago preferida</label>
                <select value={formaPago} onChange={(e) => setFormaPago(e.target.value)}>
                  <option value="transferencia">Transferencia bancaria</option>
                  <option value="payphone">Payphone (tarjeta) — recargo 5.75%</option>
                </select>
              </div>
            </div>

            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={onClose}>Cancelar</button>
              <button type="submit" className="btn-primary" disabled={enviando}>
                <Send size={16} /> {enviando ? 'Enviando...' : 'Solicitar cotización'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
